<!-- eslint-disable max-len -->
<template>
  <datepicker
    v-model='value'
    @selected=setValue
    input-class="form-control bg-white"
    :bootstrap-styling="true"
    :format="'yyyy'"
    :initialView="'year'"
    :minimumView="'year'"
    :maximumView="'year'"
    :use-utc="false"
  />
</template>

<script>
import { abstractField } from 'vue-form-generator';
import Datepicker from 'vuejs-datepicker';

export default {
  name: 'CustomYearPicker',
  mixins: [abstractField],
  components: {
    Datepicker,
  },
  methods: {
    setValue(selectedDate) {
      this.value = selectedDate;
    },
  },
};
</script>
